<div [class.is-show]="show && basicDesign" class="c-message c-message--black">
  <span>{{message}}</span>
</div>
<div [class.is-show]="show && !basicDesign" class="c-message">
  <i class="c-icon__check"></i><span>{{message}}</span>
</div>